<template>
    <b-container fluid>
        <b-row>
            <b-col cols="8">
                <b-card>
                    <h5>Информация</h5>
                    <b-form @submit.prevent="updateUserdata()">
                        <b-form-row>
                            <b-col cols="6">
                                <b-form-group label="Фамилия" label-for="profile-lastname">
                                    <b-form-input id="profile-lastname" v-model="userdata.lastname" :readonly="!editable" />
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group label="Имя" label-for="profile-firstname">
                                    <b-form-input id="profile-firstname" v-model="userdata.firstname" :readonly="!editable" />
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="6">
                                <b-form-group label="E-Mail" label-for="profile-email">
                                    <b-form-input id="profile-email" v-model="userdata.email" :plaintext_="!editable" readonly />
                                </b-form-group>
                            </b-col>
                            <b-col cols="6">
                                <b-form-group label="Логин" label-for="profile-username">
                                    <b-form-input id="profile-username" v-model="userdata.username" :plaintext_="!editable" readonly />
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="6">
                                <b-form-group label="Skype" label-for="profile-skype">
                                    <b-form-input id="profile-skype" v-model="userdata.skype" :readonly="!editable" />
                                </b-form-group>
                            </b-col>
                            <b-col cols="6"></b-col>
                        </b-form-row>

                        <!--<b-form-row class="text-right">-->
                            <b-button type="submit" v-if="editable" disabled variant="primary">Сохранить</b-button>
                            <b-button @click.prevent="editable = !editable; initUserdata()" v-if="editable" variant="secondary">Отмена</b-button>
                            <b-button @click.prevent="changeUserdata()" v-if="!editable" variant="danger">Изменить</b-button>
                        <!--</b-form-row>-->
                    </b-form>
                </b-card>
            </b-col>
            <b-col cols="4" hidden>
                <b-card>
                    <h5>Смена пароля</h5>
                    <b-form @submit.prevent="changePassword">
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: 'profile',
        data () {
            return {
                userdata: {
                    lastname: '',
                    firstname: '',
                    email: '',
                    username: '',
                    skype: '',
                    birthdate: '',
                    phone: '',
                    country: '',
                    city: '',
                    address: ''
                },
                editable: false
            }
        },
        mounted () {
            this.initUserdata()
        },
        methods: {
            initUserdata () {
                let userdata = this.$store.state.user['userdata']

                this.userdata.lastname = userdata.lastname
                this.userdata.firstname = userdata.firstname
                this.userdata.email = userdata.email
                this.userdata.username = userdata.username
                this.userdata.skype = userdata.skype
            },
            changeUserdata () {
                this.editable = true
            },
            updateUserdata () {
                this.initUserdata()
                this.editable = false
            },
            changePassword () {}
        }
    }
</script>


// WEBPACK FOOTER //
// Profile.vue?b7e27584